"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _IconWrapper = _interopRequireDefault(require("./IconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TriangleUpDownIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(TriangleUpDownIcon, _React$PureComponent);

  function TriangleUpDownIcon() {
    _classCallCheck(this, TriangleUpDownIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(TriangleUpDownIcon).apply(this, arguments));
  }

  _createClass(TriangleUpDownIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_IconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'triangle-up-down-icon'),
        viewBox: "0 0 4 8"
      }, props), _react.default.createElement("g", null, _react.default.createElement("path", {
        fill: color,
        d: "M2.38658983,0.459920339 L3.81906903,2.17889537 C3.99585107,2.39103382 3.96718904,2.70631617 3.75505059,2.88309821 C3.66519309,2.95797946 3.55192664,2.99898757 3.43495839,2.99898757 L0.57,2.99898757 C0.293857625,2.99898757 0.0700000003,2.77512995 0.0700000003,2.49898757 C0.0700000003,2.38201932 0.11100811,2.26875287 0.18588936,2.17889537 L1.61836855,0.459920339 C1.79515059,0.24778189 2.11043295,0.219119858 2.32257139,0.395901899 C2.34580293,0.415261509 2.36723022,0.436688806 2.38658983,0.459920339 Z"
      }), _react.default.createElement("path", {
        fill: color,
        d: "M2.38658983,7.5380548 L3.81906903,5.81907977 C3.99585107,5.60694132 3.96718904,5.29165897 3.75505059,5.11487693 C3.66519309,5.03999568 3.55192664,4.99898757 3.43495839,4.99898757 L0.57,4.99898757 C0.293857625,4.99898757 0.0700000003,5.2228452 0.0700000003,5.49898757 C0.0700000003,5.61595582 0.11100811,5.72922227 0.18588936,5.81907977 L1.61836855,7.5380548 C1.79515059,7.75019325 2.11043295,7.77885528 2.32257139,7.60207324 C2.34580293,7.58271363 2.36723022,7.56128634 2.38658983,7.5380548 Z"
      })));
      /* eslint-enable max-len */
    }
  }]);

  return TriangleUpDownIcon;
}(_react.default.PureComponent);

exports.default = TriangleUpDownIcon;
TriangleUpDownIcon.defaultProps = {
  color: 'inherit'
};
TriangleUpDownIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};